var cibBuzzfeed = ["32 32", "<path d='M32 16c0 8.839-7.161 16-16 16s-16-7.161-16-16c0-8.839 7.161-16 16-16s16 7.161 16 16zM26.469 15.636l-1.303-9.256-8.667 3.5 3.432 1.984-3.244 5.62-5.62-3.244-5.537 9.588 3.1 1.792 3.749-6.489 5.62 3.244 5.036-8.724z'/>"];

export { cibBuzzfeed };
